import { ChevronLeft, Close, Message } from '@mui/icons-material'
import {
  Badge,
  Box,
  Fade,
  Icon,
  IconButton,
  Paper,
  Typography
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import ChatBox from 'components/messages/chat-box'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosMessage } from 'types/nivos-message'
import { NivosUser } from 'types/user'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

interface OwnProps {
  hidden: boolean
  setHidden: (val: boolean) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const FloatingChatBoxFC: React.FC<any> = (props: AppProps) => {
  const { hidden, setHidden, user } = props

  const kausapUser: NivosUser = {
    id: 2,
    firstName: 'Jhon Aaron',
    lastName: 'Casipit',
    fullName: 'Jhon Aaron Casipit',
    image: {
      uuid: '00-00-00-00',
      name: 'image',
      url: 'https://media-exp1.licdn.com/dms/image/C4D03AQE46dQq-padhw/profile-displayphoto-shrink_800_800/0/1655882244286?e=1674086400&v=beta&t=Yov1qmXWDdubGAywd4OXAOB59KPZkOLSbmJJNDAxu3w'
    },
    email: '',
    address: '',
    groups: [],
    contactList: [],
    authenticated: true,
    loading: false
  }

  const sampleMessages: NivosMessage[] = [
    {
      id: 0,
      receiver: kausapUser,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: user
    },
    {
      id: 0,
      receiver: user,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: kausapUser
    },
    {
      id: 0,
      receiver: kausapUser,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: user
    },
    {
      id: 0,
      receiver: kausapUser,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: user
    },
    {
      id: 0,
      receiver: user,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: kausapUser
    },
    {
      id: 0,
      receiver: user,
      message:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi vehicula, porttitor nisi in, tincidunt ex. Maecenas condimentum diam',
      createdAt: new Date(),
      createdBy: kausapUser
    }
  ]

  return (
    <Box>
      <Box position={'fixed'} right={100} bottom={15} zIndex={2}>
        <Fade in={!hidden} mountOnEnter unmountOnExit>
          <Box maxHeight={'75vh'}>
            <Paper
              elevation={8}
              sx={{
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                marginBottom: '-1px'
              }}
            >
              <Box
                display={'flex'}
                alignItems={'center'}
                paddingY={1}
                paddingLeft={1}
              >
                <IconButton>
                  <ChevronLeft />
                </IconButton>
                <Typography variant={'h4'}>Back to inbox</Typography>
              </Box>
            </Paper>
            <ChatBox
              hideSendButton
              kausap={kausapUser}
              messages={sampleMessages}
              containerProps={{ width: 400, minHeight: 0, maxHeight: '65vh' }}
            />
          </Box>
        </Fade>
      </Box>
      <Paper
        elevation={8}
        sx={{
          borderRadius: '50%',
          position: 'fixed',
          bottom: 15,
          right: 20,
          zIndex: 2,
          padding: 1
        }}
      >
        <Badge badgeContent={4} color={'error'}>
          <IconButton onClick={() => setHidden(!hidden)}>
            <Icon>{hidden ? <Message /> : <Close />}</Icon>
          </IconButton>
        </Badge>
      </Paper>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const FloatingChatBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(FloatingChatBoxFC) as React.FC<OwnProps>

export default FloatingChatBox
